import React from 'react';
const SectionLine = () => {
    return (
        <div className="section-container by">
            <div className="image-column">
                <img
                    src="frame.png"
                    alt="Selo de GArantia"
                    style={{ 'maxHeight': '150px', 'maxWidth': '150px' }}

                />
            </div>
            <div className='text-column-line'>
                <h4 className='text large' style={{ 'textAlign': 'center' }}> Garantia de 7 Dias</h4>
                <p className='text' style={{ 'textAlign': 'center' }}> Seu dinheiro de volta em 7 dias sem perguntas</p>

            </div>
        </div>
    );
};

export default SectionLine;
